import React, { useState, useEffect } from 'react';
import './navbar.css';
import ProfileModal, { ProfileContent } from './profile-modal';

const Navbar = ({ links }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const name = localStorage.getItem('name');

    const toggleModal = (e) => {
        e.stopPropagation();
        setIsModalOpen(!isModalOpen);
    };

    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const toggleModal1 = () => setIsModalOpen1(!isModalOpen1);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 575);
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // initial check on mount

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isLinkActive = (link) => {
        const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
        if (link.url === '/calculators/bmi' || link.url.startsWith('/calculators')) {
            return currentPath.startsWith('/calculators');
        }
        if (link.active !== undefined) return link.active;
        if (link.url === '/') return currentPath === '/';
        return currentPath.startsWith(link.url);
    };

    return (
        <div>
            <nav className="nav-main">
                <div className="nav-container1">
                    <div className='navbar-head'>
                        <a className="navbar-brand" href="/"><span style={{ color: "#ff3131" }}>Fit</span>Realm</a>
                        {isMobile && links.length > 0 && (
                            <div>
                                <button
                                    type="button"
                                    className="hamburger-toggle"
                                    aria-label="Toggle navigation menu"
                                    aria-expanded={isModalOpen1}
                                    onClick={toggleModal1}
                                >
                                    <img className='menu-icon' alt='Menu - Fit Realm' src='/images/menu.webp' title='Menu' width='28' height='28' />
                                </button>
                            </div>
                        )}
                    </div>
                    <div className='nav-links'>
                        {links.map((link, index) => (
                            <a key={index} href={link.url} >
                                <img src={link.image} alt={link.text} className={isLinkActive(link) ? 'nav-icon active' : 'nav-icon'} title={link.text} width='28' height='28' />
                            </a>
                        ))}
                    </div>
                    <div className='profile'>
                        {(window.location.pathname === '/fit-g' || window.location.pathname === '/' || window.location.pathname === '/exerciselogs' || window.location.pathname.startsWith('/split')) && (
                            <div className="profile-container">
                                <img src="/images/user.webp" alt="Profile - Fit Realm" className="profile-icon" onClick={toggleModal} title='Profile' width="30" height="30" />
                                <p>Hi, {name}!</p>
                            </div>
                        )}
                    </div>
                </div>
                <ProfileModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            </nav>
            {isModalOpen1 && (
                <div className="m-nav">
                    <div className='m-nav-container'>
                        <span className="close" onClick={toggleModal1}><img src="/images/remove.webp" alt="Close" className="menu-icon" width="28" height="28" /></span>
                        <div className='m-nav-links'>
                            <div className="m-nav-header">
                                {links.map((link, index) => (
                                    <div key={index} className={`m-nav-table ${isLinkActive(link) ? 'active' : ''}`}>
                                        <a href={link.url}>
                                            <p>{link.text}</p>
                                            <img src={link.image} alt={link.text} className={isLinkActive(link) ? 'nav-icon active' : 'nav-icon'} title={link.text} width="28" height="28" />
                                        </a>
                                    </div>
                                ))}
                            </div>
                            <ProfileContent isMobileDrawer={true} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Navbar;
